import {createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {zadProductReplenishmentUrl, zadStockReplenishmentUrl} from '../../api'
import {parseZadApiError} from '../zad/errors'
import {
  buildZadReplenishmentQuery,
  extractZadReplenishmentDetail,
  extractZadReplenishmentList,
} from '../zad/replenishmentHelpers'
import {
  FetchZadProductReplenishmentRequest,
  FetchZadReplenishmentRequest,
  UpdateZadProductReplenishmentRequest,
} from './types'

export const fetchZadReplenishment = createAsyncThunk(
  'zadReplenishment/fetch',
  async (payload: FetchZadReplenishmentRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(`${zadStockReplenishmentUrl}?${buildZadReplenishmentQuery(payload)}`)
      const list = extractZadReplenishmentList(res.data || {})
      return {
        success: true as const,
        items: list.items,
        total: list.total,
        totalPages: list.totalPages,
        summary: list.summary,
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const fetchZadProductReplenishment = createAsyncThunk(
  'zadReplenishment/fetchProduct',
  async (payload: FetchZadProductReplenishmentRequest, {rejectWithValue}) => {
    try {
      const res = await axios.get(zadProductReplenishmentUrl(payload.productId))
      const detail = extractZadReplenishmentDetail(res.data || {})
      if (!detail) {
        return rejectWithValue({success: false as const, error: 'Product replenishment not found'})
      }
      return {success: true as const, detail}
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)

export const updateZadProductReplenishment = createAsyncThunk(
  'zadReplenishment/updateProduct',
  async (payload: UpdateZadProductReplenishmentRequest, {rejectWithValue}) => {
    try {
      const res = await axios.post(zadProductReplenishmentUrl(payload.productId), payload.body)
      return {
        success: true as const,
        detail: extractZadReplenishmentDetail(res.data || {}),
      }
    } catch (error) {
      return rejectWithValue(parseZadApiError(error))
    }
  }
)
